import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class CustomTemplateItemDataService extends DataService<typeof Model.General.Logic.ViewModels.CustomDocumentTemplateItem, Model.General.Logic.ViewModels.CustomDocumentTemplateItem, ICustomTemplateItem>{

    constructor( context: any, ctx: any) {
        super(context, ctx, false);
    }

    protected map(entity: Model.General.Logic.ViewModels.CustomDocumentTemplateItem): ICustomTemplateItem {
        return new CustomTemplateItemModel(entity);
    }
	
    public static make(context?: ContextService): CustomTemplateItemDataService {
        return new CustomTemplateItemDataService(context, ctx => ctx.CustomDocumentTemplates);
    }

    private id: number = 0;

    getNextId(): number {
        this.id--;
        return this.id;
    }

    add(userId?: number | null): Model.General.Logic.ViewModels.CustomDocumentTemplateItem {
        const entity = new Model.General.Logic.ViewModels.CustomDocumentTemplateItem();

        if (userId)
            entity.userId = userId;

        entity.languageCode = "en";
        entity.file = null;

        return entity;
    }
}

export class CustomTemplateItemModel extends EntityModel<Model.General.Logic.ViewModels.CustomDocumentTemplateItem, ICustomTemplateItem> implements ICustomTemplateItem{

    @property<CustomTemplateItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;
	
    @property<CustomTemplateItemModel>(o => o.entity.file, (o, value) => o.entity.file = value)
    public file: any;

    @property<CustomTemplateItemModel>(o => o.entity.userId, (o, value) => o.entity.userId = value)
    public userId: number;

    @property<CustomTemplateItemModel>(o => o.entity.templateId, (o, value) => o.entity.templateId = value)
    public templateId: number;

    @property<CustomTemplateItemModel>(o => o.entity.languageCode, (o, value) => o.entity.languageCode = value)
    public languageCode: string;

    @property<CustomTemplateItemModel>(o => o.entity.userName, (o, value) => o.entity.userName = value)
    public userName: string;
}




// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/parts/custom-template-list.data.ts